export default __webpack_public_path__ + "static/media/avatar_dragon8.cf3cb9a8.mp3";